// extracted by mini-css-extract-plugin
module.exports = {"container":"ExcelResequence_container__30YER Layouts_containerWithoutSidebar__3w4p5"};